const captureGoogleAdsConversion = (registrationCode, callback) => {
  const go = () => typeof callback === 'function' && callback();

  if (typeof window === 'undefined') {
    go();
    return;
  }

  if (typeof window.gtag === 'function') {
    let called = false;
    const once = () => {
      if (called) {
        return;
      }

      called = true;
      go();
    };

    window.gtag('event', 'conversion', {
      send_to: 'AW-17641554570/-84-CN_B5bsbEIqFk9xB',
      value: 0,
      currency: 'USD',
      transaction_id: registrationCode,
      event_callback: once,
    });

    setTimeout(once, 1200);
  } else {
    go();
  }
};

export default captureGoogleAdsConversion;
